
export enum EquipmentType {
  TeslaRoof = 'tesla-roof',
  TeslaSolar = 'tesla-solar',
  StandardSolar = 'standard-solar',
  StorageOnly = 'storage-only'
}

export interface IEquipmentOption {
  id: string
  image: string
  title: string
  description: string
  isTesla?: boolean
}

export const EquipmentOptions: IEquipmentOption[] = [
  {
    id: EquipmentType.TeslaRoof,
    image: '/images/tesla-roof.png',
    title: 'Tesla Roof + Powerwall 3',
    description: 'New luxury integrated solar roof with home battery backup',
    isTesla: true
  },
  {
    id: EquipmentType.TeslaSolar,
    image: '/images/tesla-solar.png',
    title: 'Tesla Solar Panels + Powerwall 3',
    description: 'Panels for your roof with home battery backup',
    isTesla: true
  },
  {
    id: EquipmentType.StandardSolar,
    image: '/images/solar-panel.jpeg',
    title: 'Standard Solar',
    description: 'Standard solar, storage and/or roof',
    isTesla: false
  },
  {
    id: EquipmentType.StorageOnly,
    image: '/images/storage-only.jpg',
    title: 'Storage Only',
    description: 'Home battery backup',
    isTesla: false
  }
]
